import {Component, Vue} from 'vue-property-decorator';
import Spinner from '@/components/Spinner.vue';
import OverlaySpinner from '@/components/OverlaySpinner.vue';
import axios from 'axios';

@Component({
    components: {
        Spinner,
        OverlaySpinner
    }
})
export default class LoadingMixin extends Vue {
    protected loading = false;
    protected saving = false;

    protected async execute(run: () => Promise<any>, defaultMessage: string): Promise<boolean> {
        let success = true;
        try {
            this.loading = true;
            await run();
        } catch (e) {
            if (axios.isCancel(e)) {
                // Do nothing
            } else {
                this.$notifyError(e, defaultMessage);
            }
            success = false;
        }
        this.loading = false;
        return success;
    }

    protected async save(run: () => Promise<any>, defaultMessage: string): Promise<boolean> {
        let success = true;
        try {
            this.saving = true;
            await run();
        } catch (e) {
            if (axios.isCancel(e)) {
                // Do nothing
            } else {
                this.$notifyError(e, defaultMessage);
            }
            success = false;
        }
        this.saving = false;
        return success;
    }
}